import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.less']
})
export class LoadingComponent implements OnInit {
    @Input() text = 'Loading...';
    @Input() size = 'fa-3x';
    @Input() visible = true;

    constructor() {
    }

    ngOnInit() {
    }

}
